import { filter, Observable } from 'rxjs';

/**
 * An observable that prevents downstream operations if the source observable returns false.
 * E.g., permissions checks like checking if user has Advanced Monitoring permissions before making AM calls
 * @param source An observable representing the access permissions request
 * @returns An observable that emits if the source returns true
 */
export function gateCall(source: Observable<boolean>): Observable<boolean> {
    return source.pipe(
        filter(hasAccess => hasAccess)
    );
}
